import dayjs from "dayjs";
import { getLookupTablePayloadId } from "../../shared/lookupTables";
import {
  normalizeTouchedKey,
  setDeepImmutable,
  toPath,
} from "../../shared/helpers/objectPath";

export {
  hasNullRequiredField,
  normalizeTouchedKey,
  setDeepImmutable,
  toPath,
} from "../../shared/helpers/objectPath";

// small utility to format date strings consistently
export const formatDate = (value: any) => {
  if (!value) return null;
  return typeof value === "string" ? value : dayjs(value).format("YYYY-MM-DD");
};

export const buildFreightRevenueBasePayload = (
  rowEdit: any,
  activeVersion: string | null,
) => ({
  routeBase: getLookupTablePayloadId(rowEdit.code, rowEdit.routeBase),
  versionId: activeVersion ?? "",
  customer: rowEdit.customerName.value,
});

export const buildFreightRevenueDetailsPayload = (rowEdit: any) => ({
  price: {
    cont20: rowEdit.price?.cont20 ?? 0,
    cont40: rowEdit.price?.cont40 ?? 0,
    cont45: rowEdit.price?.cont45 ?? 0,
    cy20: rowEdit.price?.cy20 ?? 0,
    cy40: rowEdit.price?.cy40 ?? 0,
    cy45: rowEdit.price?.cy45 ?? 0,
    splitCont20: rowEdit?.price?.splitCont20 ?? 0,
    truck: rowEdit.price?.truck ?? 0,
  },
  deliveryCost: {
    export: rowEdit.deliveryCost?.export ?? 0,
    import: rowEdit.deliveryCost?.import ?? 0,
  },
  extraFee: {
    export: rowEdit.extraFee?.export ?? 0,
    import: rowEdit.extraFee?.import ?? 0,
  },
});

export const buildFreightRevenueVersionPayload = (rowEdit: any) => ({
  name: rowEdit.name,
  note: rowEdit.note,
  validFrom: formatDate(rowEdit.validFrom),
});

export const updateFreightRevenueEditedRows = (
  rows: any[],
  key: string | string[],
  value: any,
  index: string | number,
  useNestedPath = false,
) => {
  const next = [...rows];
  const findInd = next.findIndex((item: any) => item.index === index);
  if (findInd === -1) return rows;

  const row = { ...next[findInd] };
  const record = { ...(row.record || {}) };
  const touchedKey = normalizeTouchedKey(key);
  const flatKey = typeof key === "string" ? key : touchedKey;

  row.record = useNestedPath
    ? setDeepImmutable(record, toPath(key), value)
    : { ...record, [flatKey]: value };
  row.touchedFields = { ...(row.touchedFields || {}), [touchedKey]: true };
  next[findInd] = row;

  return next;
};
